import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert';
import { Button } from '@components/ui/button';
import { useAccess } from '@hooks/access';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { version } from '../../../package.json';

export const UpdateSW = () => {
  const { t } = useTranslation('app');
  const access = useAccess();
  const [hasUpdate, setHasUpdate] = useState(false);

  const handleUpdate = () => window.location.reload();

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const handleMessage = (event: MessageEvent<{ type?: string; version?: string }>) => {
      if (event.data?.type !== 'version' || !event.data.version) return;
      if (event.data.version !== version) setHasUpdate(true);
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);
    return () => navigator.serviceWorker.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (!hasUpdate || !access.fieldUser) return;
    handleUpdate();
  }, [hasUpdate, access.fieldUser]);

  return (
    <AlertDialog open={hasUpdate}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('navigation.update.title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('navigation.update.description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button onClick={handleUpdate}>{t('actions.update')}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
